import React, { useEffect, useState } from "react";
import { Card, Descriptions, Skeleton, Tag, notification } from "antd";
import { DeviceDto } from "../../types/devicemanagementtypes";
import { getDeviceById } from "../../services/devicemanagementservice";

interface Props {
    deviceId: string;
}

const DeviceDetailsCard: React.FC<Props> = ({ deviceId }) => {
    const [device, setDevice] = useState<DeviceDto | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchDevice = async () => {
            try {
                const { data } = await getDeviceById(deviceId);
                setDevice(data);
            } catch {
                notification.error({
                    message: "Error",
                    description: "Failed to fetch device details",
                });
            } finally {
                setLoading(false);
            }
        };
        fetchDevice();
    }, [deviceId]);

    if (loading) return <Skeleton active paragraph={{ rows: 6 }} />;

    return (
        <Card bordered={false}>
            <Descriptions bordered column={2}>
                <Descriptions.Item label="Name">{device?.aliasName}</Descriptions.Item>
                <Descriptions.Item label="Status">
                    {device?.status === "1" ? (
                        <Tag color="green">Online</Tag>
                    ) : (
                        <Tag color="red">Offline</Tag>
                    )}
                </Descriptions.Item>
                <Descriptions.Item label="Banner">{device?.banner}</Descriptions.Item>
                <Descriptions.Item label="Store">{device?.store}</Descriptions.Item>
                <Descriptions.Item label="Type">{device?.type}</Descriptions.Item>
                <Descriptions.Item label="ID">{device?.identifier}</Descriptions.Item>
                <Descriptions.Item label="Manufacturer">{device?.manufacturer}</Descriptions.Item>
                <Descriptions.Item label="Device ID">{device?.deviceId}</Descriptions.Item>
                <Descriptions.Item label="Provisioned On">
                    {device?.provisionedOn ? new Date(device.provisionedOn).toLocaleString() : ""}
                </Descriptions.Item>
                <Descriptions.Item label="Updated On">
                    {device?.updatedOn ? new Date(device.updatedOn).toLocaleString() : ""}
                </Descriptions.Item>
            </Descriptions>
        </Card>
    );
};

export default DeviceDetailsCard;